import { useMemo, useState } from "react";

import ICarret from "assets/i-carret.js";
import ICheckRounded from "assets/i-check-rounded.js";

const roundAmount = (amount) => {
  if (!amount) return "";

  let temp = amount;

  if (typeof amount !== "number") temp = parseInt(amount);

  return Math.round(temp).toLocaleString("id-ID");
};

const CompanyB = ({ data }) => {
  const [isDetailAdditionalUser, setIsDetailAdditionalUser] = useState(false);

  const SECOND_COMPANY = useMemo(() => {
    const payee = data?.subscription_invoice;
    const company = data?.company;

    const note = `Bukti Potong PPh 23 harap ditujukan ke ${
      payee?.payee_company || ""
    }, paling lambat tgl 20 bulan berikutnya setelah pembayaran dilakukan.`;

    const getBadges = () => {
      let res = [];

      if(payee?.total_charge_users) {
        res.push(`Active user: ${payee?.total_charge_users}`);
      }
      if(payee?.total_quota) {
        res.push(`Kuota kantor: ${payee?.total_quota}`);
      }
      if(payee?.total_group_charge_users) {
        res.push(`Active user group: ${payee?.total_group_charge_users}`);
      }
      if(payee?.total_group_quota) {
        res.push(`Kuota group: ${payee?.total_group_quota}`);
      }

      return res;
    }

    let result = {
      name: payee?.payee_company ? `${payee.payee_company}` : "",
      address:
        "Ciputra World 2 Lt. 7F, Jl. Prof Dr Satrio Kav. 11 Jakarta 12930",
      noInvoice: payee?.invoice_number || "",
      invoiceDate: payee?.invoice_date || "",
      invoiceDueDate: payee?.due_date || "",
      tanggalBayar: payee?.paid_at || "",
      toWhom: company?.legal_name ? `${company.legal_name}` : "",
      officeName: company?.name || "",
      destinationLocation: company?.address?.street || "",
      periode: payee?.invoice_period || "",
      basePackage:
        roundAmount(payee?.subscription_detail?.base_package_amount) || "",
      additionalUserCount: payee?.subscription_detail?.extra_users,
      additionalUserPrice:
        roundAmount(payee?.subscription_detail?.price_per_extra_user) || "",
      additionalUser:
        roundAmount(payee?.subscription_detail?.additional_user_amount) || "",
      note: note,
      totalSubscription: roundAmount(payee?.withholding_tax_amount),
      netAmount: roundAmount(payee?.net_amount) || "",
      totalAmount: roundAmount(payee?.total_amount) || "",
      extraUserBreakdown: payee?.extra_user_breakdown || [],
      badges: getBadges(),
    };

    return result;
  }, [data]);
  return (
    <div className="bg-[#fff] rounded-[4px] border-[0.5px] border-solid border-[#D8D8D9]">
      {/* Header */}
      <div className="px-4 py-2 rounded-t-[4px] bg-[#F5F5F5]">
        <p className="text-[17px] leading-[27.506px] tracking-[-0.4px] font-semibold text-[#252526]">
          {SECOND_COMPANY.name}
        </p>
        <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
          {SECOND_COMPANY.address}
        </p>
      </div>

      {/* Body */}
      <div className="px-4 py-2 rounded-b-[4px]">
        {/* Info Date */}
        <div className="py-2">
          <div className="flex items-center gap-2 mb-1">
            <p className="min-w-[100px] text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
              No. Invoice:
            </p>
            <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
              {SECOND_COMPANY.noInvoice}
            </p>
          </div>
          <div className="flex items-center gap-2 mb-1">
            <p className="min-w-[100px] text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
              Tgl. Invoice:
            </p>
            <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
              {SECOND_COMPANY.invoiceDate}
            </p>
          </div>
          <div className="flex items-center gap-2 mb-1">
            <p className="min-w-[100px] text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
              {SECOND_COMPANY.tanggalBayar ? `Tanggal Bayar:` : `Jatuh tempo:`}
            </p>
            <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#C61025] flex items-center gap-1">
              {SECOND_COMPANY.tanggalBayar || SECOND_COMPANY.invoiceDueDate}
              {(SECOND_COMPANY.tanggalBayar) && <ICheckRounded color="#0D814A" />}
            </p>
          </div>
        </div>

        {/* Info To Whom */}
        <div className="py-2">
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            Kepada:
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
            {SECOND_COMPANY.toWhom}
          </p>
          <p className="text-[17px] leading-[27.506px] tracking-[-0.4px] font-semibold text-[#252526]">
            {SECOND_COMPANY.officeName}
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            {SECOND_COMPANY.destinationLocation}
          </p>
        </div>

        {/* Info Periode & GCC */}
        <div className="py-2 flex items-center justify-between">
          <p className="flex gap-1 items-center text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
            Periode <span className="font-semibold">Subscription: </span>{" "}
            <span className="font-semibold text-white bg-[#BEAF87] px-2 h-6 flex items-center justify-center">
              {SECOND_COMPANY.periode}
            </span>
          </p>
        </div>

        {/* Info Detail Amount */}
        <div className="py-2">
          <div className="px-4 py-1 flex items-center justify-between rounded-t-[0.5px] bg-[#F5F5F5]">
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              Deskripsi
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              Nominal
            </p>
          </div>
          <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#D8D8D9]">
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              Base Package
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              {SECOND_COMPANY.basePackage}
            </p>
          </div>
          <div className="px-4 flex items-center gap-2">
            {SECOND_COMPANY.badges.map((badge, index) => (
              <p key={index} className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#686A68] px-1">
                {badge}
              </p>
            ))}
          </div>
          <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px]">
            <p className="text-[11px] font-inter leading-[17.798px] tracking-[-0.4px] text-[#252526]">
              Additional User ({SECOND_COMPANY?.additionalUserCount} user x Rp
              {SECOND_COMPANY.additionalUserPrice}){" "}
              {!!SECOND_COMPANY?.extraUserBreakdown?.length && (
                <span className="text-[#808285]">
                  *ditagihkan ke kantor utama
                </span>
              )}
            </p>
            <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
              {SECOND_COMPANY.additionalUser}
            </p>
          </div>
          {/* Detail Additional User */}
          {!!SECOND_COMPANY?.extraUserBreakdown?.length && (
            <div className="px-4">
              <div className="px-2 py-1 flex items-center justify-between rounded-t-[0.5px] bg-[#F5F5F5]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  Detail Additional User
                </p>

                <button
                  onClick={() =>
                    setIsDetailAdditionalUser(!isDetailAdditionalUser)
                  }
                  className={isDetailAdditionalUser ? "rotate-180" : ""}
                >
                  <ICarret className="rotate-90" />
                </button>
              </div>
              {isDetailAdditionalUser && (
                <>
                  <div className="px-2 py-1 grid grid-cols-3">
                    <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                      Kantor
                    </p>
                    <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                      Jumlah User
                    </p>
                  </div>
                  {SECOND_COMPANY?.extraUserBreakdown?.map((item, index) => (
                    <div key={index} className="px-2 py-1 grid grid-cols-3">
                      <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                        {item.company_name}
                      </p>
                      <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#252526]">
                        {item.total_charged_users}
                      </p>
                    </div>
                  ))}
                </>
              )}
            </div>
          )}

          {/* Table Total */}
          <div className="flex items-start gap-[40px] justify-between">
            <p className="bg-[#EBF0F7] w-[405px] px-4 py-2 text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#3268AE]">
              <span className="font-semibold text-[#3268AE] mr-1">
                Catatan:
              </span>
              {SECOND_COMPANY.note}
              <br />
              <span className="font-semibold text-[#3268AE] mr-1">
                NPWP - Fitria Kusumapersada:
              </span>
              001.651.298.0-011.000
            </p>
            <div className="w-[calc(100%-405px)]">
              <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#D8D8D9]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  Total
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  {SECOND_COMPANY.netAmount}
                </p>
              </div>
              <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-b-[0.5px] border-solid border-[#D8D8D9]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  PPh 23 (2% x Total)
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#808285]">
                  ({SECOND_COMPANY.totalSubscription})
                </p>
              </div>
              <div className="px-4 py-1 flex items-center justify-between rounded-b-[0.5px] border-t-[0.5px] border-solid border-[#252526]">
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#252526]">
                  Netto
                </p>
                <p className="text-[11px] leading-[17.798px] tracking-[-0.4px] text-[#252526]">
                  {SECOND_COMPANY.totalAmount}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyB;
